import { Pipe, PipeTransform } from '@angular/core';
import { FormatService } from '../services/format.service';

@Pipe({
  name: 'formatHora'
})
export class FormatHoraPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return FormatService.formatHora(value);
  }

}
